<template>
    <v-layout class="result-wrap" justify-center :style="popup ? 'height: 103%;' : ''"
              v-if="roundData"
    >
        <div class="result-box" :style="popup ? {transformOrigin: '9% 0', transform: 'scale(0.93)', height: '1300px', backfaceVisibility: 'hidden'} : null"
             :class="!popup ? `round${$userData.round}` : ''"
        >
            <div class="popup-title" v-if="popup" style="transform: scale(1.075)">
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/title_result_popup.png" />
                <div class="tabs" v-if="!!$roundData[2]">
                    <span @click="round !== 1 && (round = 1) && $playAudio(1)" :style="round !== 1 ? 'cursor: pointer': ''">
                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_result_round1_off.png" v-show="round === 2" />
                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_result_round1_on.png" v-show="round === 1" />
                    </span>
                    <span @click="round !== 2 && (round = 2) && $playAudio(1)" :style="round !== 2 ? 'cursor: pointer': ''">
                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_result_round2_off.png" v-show="round === 1" />
                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_result_round2_on.png" v-show="round === 2" />
                    </span>
                </div>
            </div>
            <div class="result-data"
                 :style="popup ? 'margin-top: 180px; margin-left: 73px;' : ''"
            >
                <v-layout class="scene-wrap" column>
                    <div class="scene-items">
                        <div class="items">
                            <div class="item" v-for="(i, index) in 2">
                                <img :src="$resultData.factor1(gender, factor1, index, 'result')" />
                            </div>
                            <div class="item" v-for="(i, index) in 2">
                                <img :src="$resultData.factor2(gender, factor2, index, 'result')" />
                            </div>
                        </div>
                        <div class="divider">
                        </div>
                        <div class="items">
                            <div class="item" v-for="(i, index) in 2">
                                <img :src="$resultData.factor3(gender, factor3, index, spouse, hasBaby, 'result')" />
                            </div>
                            <div class="item" v-for="(i, index) in 2">
                                <img :src="$resultData.factor4(gender, factor4, index, 'result')" />
                            </div>
                        </div>
                    </div>
                </v-layout>
                <v-layout class="results">
                    <div class="badge-wrap">
                        <div class="badge-items">
                            <div class="items">
                                <div class="item"
                                     v-for="(i, index) in [1,10,4,7,2,11]" :key="index"
                                >
                                    <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/result_badge${i}_${roundData.badges[i] ? 'on' : 'off'}.png`" class="badge-img" />
                                    <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/hint_badge${i}.png`" class="badge-hint" />
                                </div>
                            </div>
                            <div class="items">
                                <div class="item"
                                     v-for="(i, index) in [5,8,3,12,6,9]" :key="index"
                                >
                                    <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/result_badge${i}_${roundData.badges[i] ? 'on' : 'off'}.png`" class="badge-img" />
                                    <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/hint_badge${i}.png`" class="badge-hint" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="factor-wrap">
                        <v-layout class="factor-items" justify-center align-center column>
                            <img :src="`https://chart.googleapis.com/chart?cht=p&chl=부|건강|관계|명예&chd=t:${factor1},${factor2},${factor3},${factor4}&chco=f6b32e|ed161e|009e80|006ecb&chs=300x200&chp=4.71&chf=bg,s,00000000`" />
                            <div class="legend w-50">
                                <v-row>
                                    <v-col cols="6">
                                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/icon_legend1.png" /> 부 ({{ getPercent(factor1) }}%)
                                    </v-col>
                                    <v-col cols="6">
                                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/icon_legend2.png" /> 건강 ({{ getPercent(factor2) }}%)
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/icon_legend3.png" /> 관계 ({{ getPercent(factor3) }}%)
                                    </v-col>
                                    <v-col cols="6">
                                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/result/icon_legend4.png" /> 명예 ({{ getPercent(factor4) }}%)
                                    </v-col>
                                </v-row>
                            </div>
                        </v-layout>
                    </div>
                </v-layout>
            </div>

            <div v-if="!popup">
                <div class="button">
                    <router-link v-if="$userData.round === 1" to="/lab">
                        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_restart.png" />
                    </router-link>
                </div>
            </div>
        </div>
    </v-layout>
</template>

<script>
    export default {
        data() {
            return {
                round: 1,
            }
        },
        computed: {
            roundData() {
                const round = this.popup ? this.round : this.$userData.round
                return this.$roundData[round]
            },
            factor1() {
                return this.roundData.factor1
            },
            factor2() {
                return this.roundData.factor2
            },
            factor3() {
                return this.roundData.factor3
            },
            factor4() {
                return this.roundData.factor4
            },
            total() {
                return this.factor1 + this.factor2 + this.factor3 + this.factor4
            },
            gender() {
                return this.roundData.gender.toLowerCase()
            },
            spouse() {
                return this.roundData.spouse
            },
            hasBaby() {
                return this.roundData.hasBaby
            }
        },

        props: [
            'popup'
        ],

        beforeMount() {
            const id = this.$cookie.get('id')
            const localUserData = localStorage.getItem(`userData${id}`)
            if (localUserData) {
                const userData = JSON.parse(localUserData)
                Object.keys(userData).forEach(key => {
                    this.$set(this.$userData, key, userData[key])
                })
            }

            const localRoundData = localStorage.getItem(`roundData${id}`)
            if (localRoundData) {
                this.$set(this, '$roundData', JSON.parse(localRoundData))
            }

            // if (!this.$userData.round) {
            //     this.$router.replace('/')
            // }

            if (!this.$roundData[this.$userData.round]) {
                if (this.$userData.ended) {
                    this.$set(this.$roundData, this.$userData.round, this.$userData)
                }
            }


        },

        mounted() {
            $('.badge-items .item').mouseover(e => {
                $(e.target).find('.badge-hint').fadeIn('fast')
            })
            $('.badge-items .item').mouseout(e => {
                $(e.target).find('.badge-hint').fadeOut('fast')
            })

            if (this.popup && !this.roundData) {
                this.$eventBus.$emit('SHOW_POPUP', '게임을 끝까지 진행한 후에\n게임 결과를 확인할 수 있습니다.')
            }

        },

        methods: {
            getPercent(val) {
                return Math.round(val / this.total * 100)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .result-wrap {
        height: 100vh;
        overflow-y: scroll;
        background-color: #19162a;

        .result-box {
            width: 1278px;
            min-height: 100%;
            position: relative;

            &.round1 {
                height: 2872px;
                background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_result1.png);
            }

            &.round2 {
                height: 1998px;
                background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_result2.png);
            }

            .popup-title {
                position: absolute;
                left: 0;
                top: 0;
                width: 1165px;

                background-color: #19162a;

                text-align: center;
                margin-top: 28px;
                margin-left: 72px;
                padding-top: 35px;

                .tabs {
                    margin-top: 16px;

                    span {
                        /*cursor: pointer;*/
                    }
                    span+span {
                        margin-left: 4px;
                    }
                }
            }

            .result-data {
                background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_result_box.png);
                margin-left: 56px;
                margin-top: 296px;

                .scene-wrap {
                    padding-top: 147px;
                    padding-left: 68px;

                    .scene-items {
                        width: 1045px;
                        height: 476px;
                        background-repeat: no-repeat;
                        background-size: cover;
                        text-align: center;

                        .items {
                            .item {
                                display: inline-block;
                                width: 244px;
                                height: 152px;
                                overflow: hidden;

                                & + .item {
                                    margin-left: 21.5px;
                                }
                            }

                            img {
                                width: 100%;
                                /*transform-origin: 50% 50%;*/
                                /*transform: scale(1);*/

                            }
                        }

                        .divider {
                            margin-top: 28.5px;
                            margin-bottom: 26px;
                            line-height: 0;
                            height: 3px;
                        }
                    }
                }

                .results {
                    margin-top: 52px;

                    .badge-wrap {
                        .badge-items {
                            width: 725px;
                            height: 385px;
                            background-repeat: no-repeat;
                            background-size: cover;
                            padding-top: 82px;
                            padding-left: 72px;

                            .items {

                                & + .items {
                                    margin-top: 17px;
                                }

                                .item {
                                    width: 89px;
                                    height: 111px;
                                    display: inline-block;
                                    text-align: center;
                                    position: relative;
                                    cursor: help;

                                    .badge-img {
                                        margin-top: 8px;
                                        pointer-events: none;
                                    }

                                    & + .item {
                                        margin-left: 17px;
                                    }

                                    .badge-hint {
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        display: none;
                                        pointer-events: none;
                                    }
                                }
                            }

                        }
                    }

                    .factor-wrap {
                        margin-left: 24px;

                        .factor-label {
                            position: relative;
                            height: 71px;

                            img {
                                position: absolute;
                                top: -22px;
                                left: -23px;
                            }
                        }

                        .factor-items {
                            width: 431px;
                            height: 406px;
                            background-repeat: no-repeat;
                            background-size: cover;

                            .legend {
                                font-family: GmarketSans, sans-serif;
                                font-weight: 300;
                                font-size: 12px;
                                color: #ffffff;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }

            .button {
                position: absolute;
                left: 556px;
                bottom: 332px;
            }
        }
    }
</style>
